import icon from '../images/app-icon.png';
import { APP_STORE_URL } from '../data';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div>
            <a className="brand" href="#top">
              <img src={icon} alt="Klingua app icon" />
              Klingua
            </a>
            <p className="tag">The fastest voice translator. Press, talk, release — in 9 languages.</p>
          </div>
          <div className="footer-links">
            <div className="footer-col">
              <h4>Product</h4>
              <a href="#features">Features</a>
              <a href="#how">How it works</a>
              <a href="#languages">Languages</a>
              <a href="#gallery">Screenshots</a>
            </div>
            <div className="footer-col">
              <h4>Get the app</h4>
              <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">App Store</a>
              <a href="#privacy">Privacy Policy</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© Klingua 2026 · Made by Lloyd Tanedo</span>
          <span>Klingua is a voice translation app for iPhone &amp; iPad.</span>
        </div>
      </div>
    </footer>
  );
}
